import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
} from "react";
import { ftchPlus, FtchPlusError, getOptions, SetupSavingRulesUrl_get } from "../App/Account_urls.jsx";
import { Container, Stack } from "@mui/material";
import { AccordianGrid, AccordionSet } from "../Components/AccordianGrid.jsx";
import { CopyIconRenderer, EditIconRenderer } from "../App/GridRenderers.jsx";

import AddSavingRule from "../App/AddSavingRule.jsx";
import AddIncomeRule from "../App/AddIncomeRule.jsx";

import { CrumbToggleScenario } from "../Components/CrumbToggles.jsx";

import { ErrorBar } from "../Components/ErrorBar.jsx";
import { Help_setupRules } from "../Dialogs/Help/Help_Setup.jsx";
import { Arrayify } from "../Functions/utils.jsx";

const SetupSavingRules = ({ clientJson, c_callback }) => {
  const clientData = useRef(null);
  const [errmsg, setErrmsg] = useState("")

  const [refetch, setRefetch] = useState(0)
  const [clients, setClients] = useState([""]);
  const [client, setClient] = useState("");
  const [spouse, setSpouse] = useState(false);
  const [desired, setDesired] = useState([]);
  const [surplus, setSurplus] = useState([]);
  const [income, setIncome] = useState([]);
  const [copy, setCopy] = useState(false)
  const [show, setShow] = useState(
    { Desired: false },
    { Surplus: false },
    { Income: false }
  );
  const [add, setAdd] = useState(
    { Desired: false },
    { Surplus: false },
    { Income: false }
  );
  const [year, setYear] = useState();
  const [noNewRules, setNoNewRules] = useState(false)
  const [addDataDisabled, setAddDataDisabled] = useState(false)
  const [openAccordion, setOpenAccordion] = useState("0")



  const icon = useRef();





  const cd_Default = useMemo(() => ({
    headerName: "Default",
    field: "Default",
    width: 85,
  }), [])
  const cd_FromSpouse = useMemo(() => ({
    headerName: "From Spouse",
    field: "FromSpouse",
    width: 85,
  }), [])

  const cd_Year = useMemo(() => ({
    headerName: "Year",
    field: "Year",
    sort: "asc",
    type: "rightAligned",
    width: 80,
  }), []);
  // const cd_UpToAge = useMemo(() => ({
  //   headerName: "UpToAge",
  //   field: "UpToAge",
  //   type: "rightAligned",
  // }), []);

  // const cd_Value = {
  //   headerName: "Value",
  //   field: "Value",
  //   valueFormatter: moneyFormatter,
  //   type: "rightAligned",
  //   width: 140,
  // };

  // const cd_ToMax = {
  //   headerName: "To Max",
  //   field: "ToMax",
  //   valueFormatter: moneyFormatter,
  //   width: 140,
  //   type: "rightAligned",
  // };
  // const cd_FromMin = {
  //   headerName: "From Min",
  //   field: "FromMin",
  //   valueFormatter: moneyFormatter,
  //   width: 140,
  //   type: "rightAligned",
  // };
  // const cd_SpousalKeepBalanced = {
  //   headerName: "Spousal: Keep Balanced",
  //   field: "SpousalKeepBalanced",
  // };

  // const cd_Min = useMemo(() => ({
  //   headerName: "Min",
  //   field: "Min",
  //   valueFormatter: moneyFormatter,
  //   type: "rightAligned",
  // }));
  // const cd_Max = useMemo(() => ({
  //   headerName: "Max",
  //   field: "Max",
  //   valueFormatter: moneyFormatter,
  //   type: "rightAligned",
  // }));
  // const cd_OnlyRequired = {
  //   headerName: "Only Required",
  //   field: "OnlyRequired",
  //   width: 130,
  //   valueFormatter: CheckboxRenderer,
  // };


  // const cd_Percent = {
  //   headerName: "Percent",
  //   field: "Percent",
  //   valueFormatter: percent0Formatter,
  //   type: "rightAligned",
  // };
  // const cd_From = {
  //   headerName: "From",
  //   field: "From",
  //   width: 240,
  // };
  // const cd_To = {
  //   headerName: "To",
  //   field: "To",
  //   width: 240,
  // };
  // const cd_AmountType = {
  //   headerName: "AmountType",
  //   field: "AmountType",
  //   width: 240,
  // };

  const cd_Edit = {
    headerName: "Edit",
    field: "Editable",
    cellRenderer: EditIconRenderer,
    cellRendererParams: {
      callback: (e) => { icon.current = e },
    },
    width: 70,
  };

  const cd_Copy = {
    headerName: "Copy",
    field: "Editable",
    cellRenderer: CopyIconRenderer,
    cellRendererParams: {
      callback: (e) => { icon.current = e },
    },
    width: 70,
  };


  const cd_TextRule = {
    headerName: "Rule",
    field: "TextRule",
    width: 1000,
    wrapText: true,
    autoHeight: true,
    "cellStyle": { "wordBreak": "normal" },
  };

  // const cd_Copy = {
  //   headerName: "Copy",
  //   field: "Editable",
  //   cellRenderer: CopyIconRenderer,
  //   cellRendererParams: {
  //     callback: (e) => { icon.current = e },
  //   },
  //   width: 70,
  // };


  // const cd_Delete = {
  //   headerName: "Delete",
  //   field: "Edit",
  //   cellRenderer: DeleteIconRenderer,
  //   cellRendererParams: {
  //     callback: (e) => { icon.current = e },
  //   },
  //   width: 70,
  // };

  // const cd_Desired = useMemo(() => [
  //   cd_Default,
  //   cd_Edit,
  //   cd_Year,
  //   cd_To,
  //   cd_From,
  //   {
  //     headerName: "How Much",
  //     children: [cd_AmountType, cd_Value, cd_Percent]
  //   },
  //   {
  //     headerName: "Subject to",
  //     children: [cd_Min, cd_Max]
  //   },
  //   {
  //     headerName: "Added Constraints",
  //     children: [cd_SpousalKeepBalanced, cd_FromMin, cd_ToMax],
  //   },
  // ]);

  const cd_Desired = useMemo(() => [cd_Edit, cd_Copy, cd_Year, cd_Default, cd_FromSpouse, cd_TextRule])


  const cd_Surplus = useMemo(() => (cd_Desired))

  const cd_Income = useMemo(() => (cd_Desired))



  // const cd_Income = useMemo(() => [
  //   cd_Default,
  //   cd_Edit,
  //   cd_Year,
  //   cd_UpToAge,
  //   cd_From,
  //   { headerName: "How Much", children: [cd_AmountType, cd_Value, cd_Percent] },
  //   { headerName: "Subject to", children: [cd_Min, cd_Max, cd_OnlyRequired] },
  //   {
  //     headerName: "Added Constraints",
  //     children: [cd_FromMin],
  //   },
  // ]);


  const NonNullArray = (v) => {
    return v ? v : []
  }

  const Update = (cl, sp) => {
    console.log("Set Client: " + cl + "," + sp);
    setClient(cl);
    setSpouse(sp)
    setNoNewRules(clientData.current[cl].NoNewRules)
    setDesired(NonNullArray(clientData.current[cl].Desired));
    setSurplus(NonNullArray(clientData.current[cl].Surplus));
    setIncome(NonNullArray(clientData.current[cl].Income));
  };

  const getData = async () => {
    console.log(clientJson);
    if (clientJson && clientJson.uuid) {
      let url = SetupSavingRulesUrl_get(clientJson, null, "");
      ftchPlus(url, getOptions)
        .then((json) => {
          if (json) {
            console.log(json);
            clientData.current = json.ClientData;
            setClients(json.Clients);
            setAddDataDisabled(json.Entitlement.AddDataDisabled)
            if (client === "") {
              Update(json.Clients[0], false);
            } else {
              Update(client, spouse);
            }
          } else {
            console.log("no such data");
          }
        })
        .catch((error) => {
          console.log(error.message);
          setErrmsg(error.message)
          FtchPlusError(error)
        });
    }
  };

  // const clientChanged = (e) => {
  //   Update(e.target.value);
  // };
  const onClientChange = (e) => {
    let sp = false
    if (e !== clients[0]) {
      sp = true
    }
    Update(e, sp);
  };

  // const DoDelete = (e) => {
  //   console.log("DoDelete");
  // };

  const cellClicked = (accountType, e, ref) => {
    setYear(e.data.Year);
    if (e.colDef.headerName === "Edit") {
      switch (icon.current) {
        case "go-edit": {
          setShow({ ...show, [accountType]: true });
          break;
        }
        default: { }

      }
    } else if (e.colDef.headerName === "Copy") {
      switch (icon.current) {
        case "go-copy": {
          setCopy(true)
          setShow({ ...show, [accountType]: true });
          break;
        }
        default: { }
      }
    }
  };

  const myClose = (acc) => {
    setCopy(false)
    setShow({ ...show, [acc]: false });
    setAdd({ ...add, [acc]: false });
    setRefetch(refetch + 1)
  };

  const addClick = (acc, e) => {
    let year = 0
    if (clientData.current !== null) {
      let json = Arrayify(clientData.current[client][acc])
      year = Math.max(...json.map((o) => o.Year), 0) + 1;
    }
    if (year === 0) {
      year = new Date().getFullYear() - 1
    }

    setYear(year);
    console.log(acc);
    setAdd({ ...add, [acc]: true });
    setShow({ ...show, [acc]: true });


  };

  // load data from sever
  // useEffect(() => {
  //   // setErrmsg("")
  //   // console.log("init get Data")
  //   // getData();
  //   setRefetch(refetch + 1)
  // }, [clientJson]);

  useEffect(() => {
    setErrmsg("")
    console.log("refetch Data " + refetch)
    getData();
  }, [refetch])

  useEffect(() => { }, [client]);

  const myAccordionOpen = (key, state) => {
    if (state) {
      setOpenAccordion(key)
    } else {
      setOpenAccordion("")
    }
  }

  const My_AccordianGrid = ({ ...otherProps }) => {
    return (
      <AccordianGrid
        add={!(noNewRules || addDataDisabled)}
        addClick={addClick}
        cellClickedListener={cellClicked}
        onClick_kb={myAccordionOpen}
        openKey={openAccordion}
        {...otherProps}
      />
    )
  }

  return (
    <div style={{ display: "flex" }}>
      <Container maxWidth="true">
        <Stack spacing={2}>
          <Stack direction="row" spacing={2}>
            <CrumbToggleScenario
              set={clients}
              current={client}
              clientJson={clientJson}
              onChange={onClientChange}
              crumbClose={c_callback}
            />
          </Stack>

          <AccordionSet >
            <My_AccordianGrid
              eventKey="0"
              name="Desired"
              type="Saving Rules"
              accountType="Desired"
              columnDef={cd_Desired}
              data={desired}
            />
            <My_AccordianGrid
              eventKey="1"
              name="Surplus"
              type="Saving Rules"
              accountType="Surplus"
              columnDef={cd_Surplus}
              data={surplus}
            />
            <My_AccordianGrid
              eventKey="2"
              name="Additional Income"
              type="Rules"
              accountType="Income"
              columnDef={cd_Income}
              data={income}
            />
          </AccordionSet>
          <AddSavingRule
            show={show.Desired}
            add={add.Desired}
            when="desired"
            year={year}
            accountType="Desired"
            close={myClose}
            client_p={client}
            clientJson={clientJson}
            c_callback={c_callback}
            spouseFirst={spouse}
            no_from_allowed={true}
            copy={copy}
          />
          <AddSavingRule
            show={show.Surplus}
            add={add.Surplus}
            when="surplus"
            year={year}
            accountType="Surplus"
            close={myClose}
            client_p={client}
            clientJson={clientJson}
            c_callback={c_callback}
            spouseFirst={spouse}
            copy={copy}
          />
          <AddIncomeRule
            show={show.Income}
            add={add.Income}
            year={year}
            accountType="Income"
            close={myClose}
            client_p={client}
            clientJson={clientJson}
            c_callback={c_callback}
            spouseFirst={spouse}
            copy={copy}
          />
        </Stack>
        <Help_setupRules />
        <ErrorBar error={errmsg} />
      </Container>
    </div>
  );
};

export default SetupSavingRules;
